var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DataGrid',{attrs:{"endpoint":("api/users/" + (_vm.user.idUser) + "/files"),"columns":_vm.columns,"primary":_vm.primary,"folder":("/users/" + (_vm.user.idUser) + "/files"),"enableLanguages":false}})}
var staticRenderFns = []

export { render, staticRenderFns }